import { useEffect } from 'react';
import { useSettingsStore } from '../store/tenantStore';
import { getPresetById } from '../config/themePresets';

/**
 * Dynamically updates the favicon based on the active theme
 * BrandsMart: "B" on white background
 * 301io: "3" on white background
 */
export function useThemeFavicon() {
  const settings = useSettingsStore((state) => state.settings);

  useEffect(() => {
    const activeTheme = getPresetById(settings?.colorTheme ?? '301io');
    
    // Generate SVG favicon based on theme
    let svg: string;
    
    if (activeTheme.id === 'brandsmart') {
      // "B" letter on white background with subtle border
      svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'>
        <rect width='32' height='32' rx='6' fill='white'/>
        <rect width='32' height='32' rx='6' fill='none' stroke='%23E5E7EB' stroke-width='1'/>
        <text x='16' y='24' font-family='Inter, -apple-system, sans-serif' font-size='20' font-weight='700' text-anchor='middle' fill='%230059B3'>B</text>
      </svg>`;
    } else {
      // "3" letter on white background with subtle border
      svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'>
        <rect width='32' height='32' rx='6' fill='white'/>
        <rect width='32' height='32' rx='6' fill='none' stroke='%23E5E7EB' stroke-width='1'/>
        <text x='16' y='24' font-family='DM Sans, -apple-system, sans-serif' font-size='20' font-weight='700' text-anchor='middle' fill='%23E20074'>3</text>
      </svg>`;
    }

    // Encode SVG for data URI
    const encodedSvg = encodeURIComponent(svg);
    const faviconUrl = `data:image/svg+xml,${encodedSvg}`;

    // Update favicon
    let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
    
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    
    link.type = 'image/svg+xml';
    link.href = faviconUrl;
  }, [settings?.colorTheme]);
}
